/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {ApplicationPage} from '@ion/core/src/types/pages';
import {Route} from '../routes/RouteDefinitions';

// defines the type for an individual ion page ...
export interface Page extends ApplicationPage {
  route?: Route
}

// defines the default ion application page state interface ...
export interface PageState {
  isInitialized: boolean;
};

export interface TopSheet {
  activeTopSheet: null | string;
  desktopTopSheetOpen: boolean;
  mobileTopSheetOpen: boolean;
};

export enum MobileLayoutHeightOffset {
  TRACKING_MAP = 164,
  TRACKING_HISTORY_MAP = 72,
  SHIPMENT_HISTORY_MAP = 56
};

export enum TrackingContainerHeightOffset {
  FILTER_SELECTED_BAR_OPEN = 158,
  FILTER_SELECTED_BAR_COLLAPSED = 92,
  NO_FILTER_BAR_OPEN = 114,
  NO_FILTER_BAR_COLLAPSED = 46,
  MOBILE_DEFAULT = 270,
  MOBILE_DEFAULT_WITHOUT_SEARCH = 220
};
